<button class="blue-button" (click)=newPoll()>
  <span *ngIf="buttonPlus">+&nbsp;&nbsp;&nbsp;</span>{{buttonText}}
</button>